export default function Loading() {
  return (
    <img
      alt="Loading"
      src="https://media4.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif?cid=6c09b952wx22553zqoc1miduodddmvlnusld1gs0t5h4c7w7&ep=v1_gifs_search&rid=200w.gif&ct=g"
    ></img>
  );
}
